import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const TeacherId = localStorage.getItem("Teacher_id");
const jsonTeacherId = JSON.parse(TeacherId);

const DraftCardPopup = ({ props, setDeleteConfirmation2, setHwId2 }) => {
  setHwId2(props);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth: 120,
      }}
    >
      <Stack spacing={2}>
        <Link
          to={`/Draft_Q_list_HW`}
          state={{ homework_id: props }}
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="outlined"
            color="warning"
            startIcon={<EditIcon />}
            fullWidth
            sx={{ textTransform: "none", whiteSpace: "nowrap" }}
          >
            Edit
          </Button>
        </Link>

        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          fullWidth
          sx={{ textTransform: "none", whiteSpace: "nowrap" }}
          onClick={() => setDeleteConfirmation2(true)}
        >
          Delete
        </Button>
      </Stack>
    </Box>
  );
};

export default DraftCardPopup;
